(function () {
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  document.querySelectorAll("[data-rs-gallery]").forEach((root) => {
    const track = root.querySelector("[data-rs-track]");
    const slides = Array.from(root.querySelectorAll("[data-rs-slide]"));
    const thumbsWrap = root.querySelector("[data-rs-thumbs]");
    const thumbs = thumbsWrap ? Array.from(root.querySelectorAll("[data-rs-thumb]")) : [];
    const prevBtn = root.querySelector("[data-rs-prev]");
    const nextBtn = root.querySelector("[data-rs-next]");

    if (!track || slides.length === 0) return;

    let index = 0;

    function setIndex(next) {
      index = clamp(next, 0, slides.length - 1);
      track.style.transform = `translateX(${-index * 100}%)`;

      if (thumbs.length) {
        thumbs.forEach((b, i) => {
          const active = i === index;
          b.classList.toggle("is-active", active);
          b.setAttribute("aria-current", active ? "true" : "false");
        });

        // Keep active thumb in view
        const activeThumb = thumbs[index];
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
        }
      }

      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    function next() { setIndex(index + 1); }
    function prev() { setIndex(index - 1); }

    if (nextBtn) nextBtn.addEventListener("click", next);
    if (prevBtn) prevBtn.addEventListener("click", prev);

    thumbs.forEach((btn) => {
      btn.addEventListener("click", () => {
        const i = Number(btn.getAttribute("data-index"));
        if (!Number.isNaN(i)) setIndex(i);
      });
    });

    // Swipe (mobile)
    let startX = 0;
    let dx = 0;
    let isDown = false;

    const viewport = root.querySelector(".rs-viewport");
    if (viewport) {
      viewport.addEventListener("pointerdown", (e) => {
        isDown = true;
        startX = e.clientX;
        dx = 0;
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener("pointermove", (e) => {
        if (!isDown) return;
        dx = e.clientX - startX;
      });

      viewport.addEventListener("pointerup", () => {
        if (!isDown) return;
        isDown = false;

        if (Math.abs(dx) > 40) {
          if (dx < 0) next();
          else prev();
        }
      });
    }

    setIndex(0);
  });
})();
